import { IntlShape } from "react-intl";

import { listingAwardsBadgeCategories } from "~/components/listings/hero-section/photo-gallery/AwardsWinnerBadge/AwardsWinnerBadge.consts";
import { AwardType } from "~/types/api-types";

/**
 * This function is used to get the year of the awards winner.
 * @returns The year of the awards winner, defaults to 0 if no year is found.
 */
const getAwardsWinnerYear = (
  listingAwards: Record<string, unknown>,
): number => {
  const years = Object.keys(listingAwards).reduce(
    (allYears: number[], currentYear) => {
      // this is a check to see if keys of listingAwards can be converted into numbers

      // checking if the current year can be converted to a number and add it to the array
      if (!isNaN(+currentYear)) {
        return [...allYears, +currentYear];
      } else {
        // if the current year cannot be converted to a number, return the array of years
        return allYears;
      }
    },
    [],
  );
  // return the highest year from the array of years, else return 0
  return years.length > 0 ? Math.max(...years) : 0;
};

/**
 * This function is used to get the category of the awards winner from the listing awards
 */
const getAwardsWinnerCategory = (
  listingAwards: Record<string, unknown>,
  intl: IntlShape,
): string => {
  if (
    listingAwards.type !== "category" ||
    typeof listingAwards.category !== "string"
  ) {
    return "";
  }

  const categoryKey = listingAwards.category
    .toLowerCase()
    .replaceAll(" ", "_") as AwardType;

  return listingAwardsBadgeCategories[categoryKey]
    ? intl.formatMessage(listingAwardsBadgeCategories[categoryKey])
    : "";
};

export { getAwardsWinnerCategory, getAwardsWinnerYear };
